import React from 'react';

const sections = [
  {
    heading: '총칙',
    body: [
      `오잉랩(브랜드명 "코레디", 이하 "회사")은 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 관련 고충을 신속·원활하게 처리하기 위하여 본 개인정보처리방침을 수립·공개합니다. 본 방침은 기업회원 및 기업회원의 담당자에게 적용되며, 개인회원에 대해서는 별도의 개인정보처리방침(개인회원)이 적용됩니다.`,
    ],
  },
  {
    heading: '제1조 (개인정보의 처리 목적 및 처리 근거)',
    body: [
      `① 회사는 다음의 목적을 위하여 개인정보를 처리하며, 각 수집 항목별 처리 근거는 「개인정보 보호법」 제15조 제1항 각 호에 따라 아래와 같이 정합니다.`,
      {
        type: 'table',
        headers: ['구분', '수집 항목', '처리 목적', '처리 근거'],
        rows: [
          [
            '회원가입 및 기업 인증',
            '기업명, 사업자등록번호, 대표자명, 사업장 주소, 업종, 담당자 성명·연락처·이메일(아이디), 비밀번호, 사업자등록증 등 사업자 증빙서류',
            '가입의사 확인, 기업 및 담당자 식별, 회원 관리, 부정이용 방지, 각종 알림 및 통지',
            '계약의 이행(제4호) 또는 동의(제1호)',
          ],
          [
            '채용공고 등록',
            '기업명, 대표자명, 사업장 주소, 업종, 담당자 성명·연락처·이메일',
            '구인자의 신원 확인 및 허위 구인정보 게재 방지',
            '법적 의무(제2호) — 「직업안정법 시행령」 제28조\n계약의 이행(제4호)',
          ],
          [
            '유료서비스 이용',
            '결제 수단 및 통화, 결제 금액·상태·일자, 환불 상태, 결제 승인번호 또는 거래ID',
            '결제·환불 처리 및 요금 정산',
            '계약의 이행(제4호), 법적 의무(제2호)',
          ],
          [
            '고객문의 및 상담',
            '담당자 성명, 연락처, 이메일, 기업명, 부서명',
            '신원 확인, 민원사항 확인, 사실 조사를 위한 연락 및 통지, 처리결과 통보',
            '계약의 이행(제4호) 또는 동의(제1호)\n분쟁처리 기록은 법적 의무(제2호)',
          ],
          [
            '서비스 이용에 따른 자동 수집',
            '기기·브라우저 종류, 방문 페이지 및 이동경로, 대략적 지역(정확한 위치 아님), 접속시간·오류 등 로그, 쿠키',
            '접속 관리, 이용 현황 분석, 서비스 개선, 부정이용 방지',
            '정당한 이익(제6호) 또는 동의(제1호)',
          ],
        ],
      },
      ``,
      `② 회사는 정당한 이익을 근거로 처리하는 경우 그 이익이 정보주체의 권리보다 우선함이 명백한 범위에서만 처리합니다.`,
      ``,
      `③ 담당자는 동의를 근거로 처리되는 항목에 대하여 동의를 거부할 수 있습니다. 다만 해당 항목의 동의를 거부하는 경우 관련 서비스의 이용이 제한될 수 있습니다.`,
    ],
  },
  {
    heading: '제2조 (수집하는 개인정보의 항목)',
    body: [
      `① (필수) 기업명, 사업자등록번호, 대표자명, 사업장 주소, 업종, 담당자 성명, 담당자 연락처, 이메일(아이디), 비밀번호`,
      ``,
      `② (기업 인증 시) 사업자등록증 등 사업자 정보를 확인할 수 있는 증명서`,
      ``,
      `③ (채용공고 등록 시) 채용공고에 포함되는 기업정보 및 담당자 연락처`,
      ``,
      `④ (결제 시) 결제 수단 및 통화, 결제 금액·상태·일자, 환불 상태, 결제 승인번호 또는 거래ID(PayPal 거래ID 포함). 회사는 카드번호 전체를 자체 서버에 저장하지 않으며, 결제정보는 결제대행사를 통하여 처리됩니다.`,
      ``,
      `⑤ (자동수집) 기기·브라우저 종류, 방문 페이지 및 이동경로, 대략적 지역(정확한 위치 아님), 접속시간·오류 등 로그`,
    ],
  },
  {
    heading: '제3조 (개인정보의 수집 방법)',
    body: [
      `회사는 회원가입, 기업 인증, 채용공고 등록, 서비스 이용, 결제, 문의·상담 및 웹사이트 이용 과정에서 정보주체가 직접 입력하거나 자동수집장치(쿠키 등)를 통하여 개인정보를 수집합니다.`,
    ],
  },
  {
    heading: '제4조 (개인정보의 처리 및 보유기간)',
    body: [
      `① 회사는 원칙적으로 처리 목적이 달성되거나 회원 탈퇴 시 지체 없이 개인정보를 파기하며, 서비스별 보유기간은 다음과 같습니다.`,
      {
        type: 'table',
        headers: ['구분', '보유기간'],
        rows: [
          ['회원가입 및 회원 관리 정보', '회원 탈퇴 시까지'],
          ['채용공고 등록 정보', '채용공고 게재 종료 후 또는 회원 탈퇴 시까지'],
          ['유료서비스 이용 정보', '유료서비스 해지 시까지'],
          ['고객문의 및 상담 기록', '처리 완료일부터 1년'],
          ['자동수집 정보', '회원 탈퇴 시까지'],
        ],
      },
      ``,
      `② 제1항에도 불구하고 관련 법령에 따라 다음의 정보는 정해진 기간 동안 보관합니다.`,
      {
        type: 'table',
        headers: ['보존 항목', '보존 기간', '근거 법령'],
        rows: [
          [
            '계약 또는 청약철회 등에 관한 기록',
            '5년',
            '전자상거래법 시행령 제6조',
          ],
          [
            '대금결제 및 재화등의 공급에 관한 기록',
            '5년',
            '전자상거래법 시행령 제6조',
          ],
          [
            '소비자 불만 또는 분쟁처리에 관한 기록',
            '3년',
            '전자상거래법 시행령 제6조',
          ],
          ['표시·광고에 관한 기록', '6개월', '전자상거래법 시행령 제6조'],
          [
            '세금계산서·영수증 등 거래내역 관련 정보',
            '5년',
            '부가가치세법',
          ],
          [
            '웹사이트 접속기록(로그)',
            '3개월 이상',
            '통신비밀보호법, 안전성 확보조치 기준',
          ],
        ],
      },
      ``,
      `③ 관계 법령 위반에 따른 수사·조사가 진행 중이거나 회사와의 채권·채무관계가 남아 있는 경우에는 해당 절차가 종료되거나 정산이 완료될 때까지 보관합니다.`,
      ``,
      `④ 계정 삭제 후에도 법령상 보관 의무가 있는 정보는 다른 개인정보와 분리하여 보관하며, 법령에서 정한 목적 외로 이용하지 않습니다.`,
    ],
  },
  {
    heading: '제5조 (지원자 개인정보의 취급)',
    body: [
      `① 회사는 개인회원이 회원의 채용공고에 지원하는 경우에 한하여 지원자의 이력서 및 제출 서류를 해당 회원에게 제공합니다. 회사는 회원이 지원 없이 개인회원의 이력서를 검색하거나 열람할 수 있는 기능을 제공하지 않습니다.`,
      ``,
      `② 회원이 제공받은 지원자의 개인정보에 대하여 회원은 「개인정보 보호법」상 개인정보처리자의 지위를 가지며, 그 처리에 관한 책임은 회원이 부담합니다.`,
      ``,
      `③ 회원은 제공받은 지원자의 개인정보를 채용 또는 인력 모집 목적으로만 이용하여야 하며, 영업·마케팅 목적으로 활용하거나 제3자에게 제공할 수 없습니다.`,
      ``,
      `④ 지원자의 제출 서류에 대한 회원의 열람 권한은 다음 기준에 따라 종료되며, 회사는 해당 시점에 열람 권한을 자동으로 만료처리합니다.`,
      `· 최종 합격 시: 공식 입사일부터 90일이 되는 날`,
      `· 불합격 시: 해당 채용 절차가 종료된 즉시`,
      ``,
      `⑤ 회원은 열람 권한이 종료된 지원자의 개인정보를 지체 없이 파기하여야 합니다. 다만 「채용절차의 공정화에 관한 법률」 등 관련 법령에 따라 보관이 필요한 경우에는 해당 법령에서 정한 기간 동안 보관한 후 지체 없이 파기합니다.`,
      ``,
      `⑥ 지원자 개인정보의 취급에 관한 세부 사항은 기업회원 이용약관 제8조에서 정합니다.`,
    ],
  },
  {
    heading: '제6조 (개인정보의 제3자 제공)',
    body: [
      `① 회사는 정보주체의 개인정보를 제1조의 목적 범위에서만 처리하며, 「개인정보 보호법」 제17조·제18조에 따라 정보주체의 동의가 있거나 법령에 근거가 있는 경우에 한하여 제3자에게 제공합니다.`,
      ``,
      `② 회원이 등록한 기업정보와 채용공고는 서비스를 방문하는 이용자에게 공개됩니다. 회원이 채용공고에 담당자 성명·연락처 등 개인정보를 포함하는 경우, 회원은 해당 정보주체로부터 공개에 관한 동의를 받아야 하며 그에 대한 책임을 부담합니다.`,
    ],
  },
  {
    heading: '제7조 (개인정보 처리의 위탁)',
    body: [
      `① 회사는 서비스 제공을 위하여 아래와 같이 개인정보 처리업무를 위탁하고 있으며, 「개인정보 보호법」 제26조에 따라 위탁 사실을 공개하고 수탁자를 관리·감독합니다.`,
      {
        type: 'table',
        headers: ['수탁자', '위탁 업무', '비고'],
        rows: [
          ['Amazon Web Services', '클라우드 호스팅·데이터 보관', '서울 리전'],
          [
            'Toss Payments, PayPal',
            '결제·환불 처리',
            'PayPal은 국외 처리(제8조)',
          ],
          [
            'Google (Analytics 4), Microsoft (Clarity)',
            '서비스 이용 분석·개선',
            '국외 처리(제8조)',
          ],
        ],
      },
      ``,
      `② 회사는 위탁계약 시 개인정보의 목적 외 처리 금지, 기술적·관리적 보호조치, 재위탁 제한, 관리·감독 및 손해배상 등에 관한 사항을 정하고 정기적으로 관리·감독합니다. 수탁자 또는 위탁업무의 내용이 변경되는 경우 지체 없이 본 방침을 통하여 공개합니다.`,
    ],
  },
  {
    heading: '제8조 (개인정보의 국외 이전)',
    body: [
      `① 회사의 서버(AWS)는 대한민국(서울 리전)에 위치합니다. 다만 아래 수탁자를 통하여 개인정보가 국외에서 처리될 수 있으며, 회사는 「개인정보 보호법」 제28조의8에 따라 그 사실을 공개하고 필요한 경우 정보주체의 동의를 받거나 법정 요건을 갖춥니다.`,
      {
        type: 'table',
        headers: ['이전받는 자', '이전 국가', '이전 항목', '이전 목적·보유기간'],
        rows: [
          [
            'Google LLC',
            '미국 등',
            '접속·이용 분석데이터',
            '서비스 분석 / 각 서비스 정책에 따름',
          ],
          [
            'Microsoft Corp.',
            '미국 등',
            '이용행태 분석데이터',
            '사용성 개선 / 각 서비스 정책에 따름',
          ],
          [
            'PayPal',
            '미국 등',
            '결제 관련 정보',
            '해외 결제 처리 / 각 서비스 정책에 따름',
          ],
        ],
      },
    ],
  },
  {
    heading: '제9조 (쿠키 등 자동수집장치의 설치·운영 및 거부)',
    body: [
      `① 회사는 서비스 운영 및 이용현황 분석을 위하여 쿠키를 사용하며, Google Analytics 4 및 Microsoft Clarity를 통하여 이용행태 데이터를 수집할 수 있습니다.`,
      ``,
      `② 이용자는 브라우저 설정을 통하여 쿠키 저장을 거부할 수 있으며, 이 경우 일부 서비스 이용에 제한이 있을 수 있습니다.`,
      ``,
      `③ 회사는 분석 도구를 통한 행태정보 수집에 대하여 이용자가 동의 여부를 선택할 수 있도록 쿠키 동의 배너 등 동의 절차를 마련합니다.`,
    ],
  },
  {
    heading: '제10조 (정보주체의 권리·의무 및 행사방법)',
    body: [
      `① 정보주체는 회사에 대하여 언제든지 개인정보 열람, 정정·삭제, 처리정지 및 동의 철회를 요구할 수 있습니다.`,
      ``,
      `② 회사는 열람 요구를 받은 날부터 10일 이내에 열람 여부를 결정하여 통지하며, 정정·삭제(제36조) 및 처리정지(제37조) 요구에 대하여도 관련 법령이 정한 기간 내에 조치합니다.`,
      ``,
      <>
        ③ 권리 행사는{' '}
        <a href='mailto:contact@ko-ready.com' className='underline'>
          contact@ko-ready.com
        </a>{' '}
        또는 서비스 내 계정 관리 메뉴를 통하여 할 수 있으며, 회사는 본인 확인
        절차를 거친 후 조치합니다. 대리인을 통한 경우 위임장을 제출받습니다.
      </>,
      ``,
      `④ 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 삭제를 요구할 수 없으며, 「개인정보 보호법」 제35조 제4항·제37조 제2항에 따라 열람 및 처리정지 요구가 제한될 수 있습니다.`,
    ],
  },
  {
    heading: '제11조 (개인정보의 파기절차 및 방법)',
    body: [
      `① 회사는 보유기간이 경과하거나 처리 목적이 달성된 개인정보를 선정하여 개인정보 보호책임자의 승인을 받아 지체 없이 파기합니다.`,
      ``,
      `② 전자적 파일은 복구·재생할 수 없는 기술적 방법으로 삭제하고, 종이 문서는 분쇄하거나 소각하여 파기합니다.`,
    ],
  },
  {
    heading: '제12조 (개인정보의 안전성 확보조치)',
    body: [
      `회사는 「개인정보 보호법」 제29조에 따라 다음의 조치를 취합니다.`,
      `· 관리적 조치: 내부관리계획 수립·시행, 개인정보취급자 교육`,
      `· 기술적 조치: 개인정보 접근권한의 관리 및 접근통제, 개인정보의 암호화, 접속기록의 보관 및 위·변조 방지, 보안프로그램 설치 및 갱신`,
      `· 물리적 조치: 자료 보관 장소의 접근통제`,
    ],
  },
  {
    heading: '제13조 (개인정보 보호책임자)',
    body: [
      `① 회사는 개인정보 처리에 관한 업무를 총괄하고 정보주체의 고충을 처리하기 위하여 개인정보 보호책임자를 지정합니다.`,
      ``,
      <>
        ② 개인정보 보호책임자: 권하연 / 연락처:{' '}
        <a href='mailto:contact@ko-ready.com' className='underline'>
          contact@ko-ready.com
        </a>
      </>,
      ``,
      `③ 정보주체는 서비스를 이용하면서 발생한 개인정보 관련 문의, 불만처리, 피해구제에 관한 사항을 개인정보 보호책임자에게 문의할 수 있으며, 회사는 지체 없이 답변하고 처리합니다.`,
    ],
  },
  {
    heading: '제14조 (권익침해 구제방법)',
    body: [
      `정보주체는 아래 기관에 개인정보 침해에 관한 분쟁 해결이나 상담을 신청할 수 있습니다.`,
      <>
        · 개인정보분쟁조정위원회: 1833-6972 (
        <a
          href='https://www.kopico.go.kr'
          target='_blank'
          rel='noopener noreferrer'
          className='underline'
        >
          www.kopico.go.kr
        </a>
        )
      </>,
      <>
        · 개인정보침해신고센터: (국번 없이) 118 (
        <a
          href='https://privacy.kisa.or.kr'
          target='_blank'
          rel='noopener noreferrer'
          className='underline'
        >
          privacy.kisa.or.kr
        </a>
        )
      </>,
      `· 대검찰청 사이버수사과: 1301 / 경찰청 사이버수사국: 182`,
      ``,
      <>
        「개인정보 보호법」 제35조·제36조·제37조에 따른 요구에 대하여 공공기관의
        장이 행한 처분 또는 부작위로 권리 또는 이익을 침해받은 자는
        「행정심판법」에 따라 행정심판을 청구할 수 있습니다. (중앙행정심판위원회
        110,{' '}
        <a
          href='https://simpan.go.kr'
          target='_blank'
          rel='noopener noreferrer'
          className='underline'
        >
          simpan.go.kr
        </a>
        )
      </>,
    ],
  },
  {
    heading: '제15조 (개인정보처리방침의 변경)',
    body: [
      `이 방침은 법령·서비스의 변경에 따라 개정될 수 있으며, 회사는 변경 내용이 이용자에게 불리한 경우 적용일 30일 전부터, 그 외의 경우 적용일 7일 전부터 이메일 또는 사이트 공지를 통하여 안내합니다.`,
    ],
  },
  {
    chapter: '부칙',
    heading: '시행일',
    body: [
      `이 방침은 2026년 08월 28일부터 시행합니다.`,
      ``,
      <>
        코레디 (Koready) |{' '}
        <a href='mailto:contact@ko-ready.com' className='underline'>
          contact@ko-ready.com
        </a>{' '}
        | 개인정보 보호책임자: 권하연
      </>,
    ],
  },
];

/** 정책 문서 한 버전. PolicyDocument가 레지스트리를 통해 읽어 렌더링한다. */
export default {
  title: '기업회원 개인정보처리방침',
  lastUpdated: '2026년 8월 28일',
  lastUpdatedLabel: '시행일',
  effectiveDate: '2026-08-28',
  sections,
};
